import initGoogleAuth from "components/jiffy/user-auth-external/user-auth-external";

document.addEventListener("DOMContentLoaded", initGoogleAuth);
